export enum ActionTypes {
  SET_ROLE_INFO = "[NAVIGATION] SET ROLE INFO",
  SET_MERCHANT = "[NAVIGATION] SET MERCHANT",
  SET_ACTIVE_ROUTE = "[NAVIGATION] SET ACTIVE ROUTE",
  SET_APP_LOADED = "[NAVIGATION] SET APP LOADED",
  SET_NOTIFICATION = "[NAVIGATION] SET_NOTIFICATION",
  SET_STATUS_SESSION_VALUES = "[NAVIGATION] SET_STATUS_SESSION_VALUES",
}
